import consentthing from "@/components/consentDeclaration/consentDeclarationCard.vue"
import userService from "@/services/userService"

const classicAcademyRights = ["aka_fetch", "aka_teacher", "aka_manage"]
const allAcademyRights = [...classicAcademyRights, "aka_leadership", "aka_leadership_manage"]

function createAcademyMeta({ navbarTitle, backTo, rights }) {
  return {
    hideBottomNavigation: true,
    hideAppBar: true,
    backgroundColor: "#121212",
    fullWidth: true,
    showRouteAppBar: true,
    showBackButton: true,
    profileSettingsInAppBar: true,
    navbarTitle,
    backTo,
    rights,
  }
}

function getAcademyTrackPath(route) {
  return route.query && route.query.from === "leadership" ? "/akademie/leadership/coaching" : "/akademie/suite"
}

function getAcademyModulePath(route) {
  return {
    path: `/akademie/modules/${route.params.id}`,
    query: route.query && route.query.from === "leadership" ? { from: "leadership" } : {},
  }
}

export default [
  {
    path: "/",
    name: "Home",
    meta: {
      navbarTitle: "roody",
      fullWidth: true,
      backgroundColor: "#212121",
    },
    component: () => import("@/views/HomeNew_new.vue"),
    /*  // Hier prüfen wir jetzt sauber über den Service
      const userEmail = userService.getEmail()

      const isAdminUser = userEmail === "dominic.ammann.ch@gmail.com" || userEmail === "sebs@wellcomefit.ch"

      return isAdminUser ? import("@/views/HomeNew_new.vue") : import("@/views/HomeNew_new.vue")
    */
    children: [
      {
        path: "select-employee",
        name: "selectEmployee",
        meta: {
          navbarTitle: "Mitarbeiter Auswahl",
          fullWidth: true,
          backgroundColor: "#212121",
          hideBottomNavigation: true, // Versteckt die untere Navigation
          // Hier kannst du weitere Meta-Tags hinzufügen
        },
        // Lädt die Dialog-Komponente als Seiteninhalt
        component: () => import("@/components/employee/employeeSelectionDialog.vue"),
      },
    ],
  },

  {
    name: "planningDashboard",
    path: "/plen",
    meta: { hideBottomNavigation: true, backgroundColor: "#121212", hideAppBar: false, fullWidth: true },

    component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/planning/PlanningMain.vue"),
  },

  {
    name: "employeeCourses",
    path: "/employee-courses", // WICHTIG: Route heisst 'party' wie gewünscht
    component: () => import("@/views/gf/employee/EmployeeCoursesRegistration.vue"),
    meta: { hideBottomNavigation: true, backgroundColor: "#121212", hideAppBar: false, fullWidth: true },
  },

  {
    name: "employeeCoursesAdmin",
    path: "/employee-courses/admin", // WICHTIG: Route heisst 'party' wie gewünscht
    component: () => import("@/views/gf/employee/EmployeeCoursesAdmin.vue"),
    meta: { hideBottomNavigation: true, backgroundColor: "#121212", hideAppBar: true, fullWidth: true },
  },

  {
    name: "hyroxSimulation",
    path: "/hyrox-simulation", // WICHTIG: Route heisst 'party' wie gewünscht
    component: () => import("@/views/hyrox/simulation/HyroxSimulationRegistration.vue"),
    meta: {
      hideBottomNavigation: true,
      backgroundColor: "#212121",
      fullWidth: true,
      hideAppBar: true,
      needsLoader: false,
      navbarTitle: "HYROX SIMULATION",
      hideLogo: true,
    }, // Rechte anpassen falls nötig
  },

  {
    name: "hyroxScore",
    path: "/hyrox-score", // WICHTIG: Route heisst 'party' wie gewünscht
    component: () => import("@/views/hyrox/score/HyroxScoreRegistration.vue"),
    meta: {
      hideBottomNavigation: true,
      backgroundColor: "#212121",
      fullWidth: true,
      needsLoader: false,
      navbarTitle: "HYROX SCORE",
      hideLogo: true,
    }, // Rechte anpassen falls nötig
  },
  // --- AKADEMIE MODUL START ---
  {
    path: "/akademie",
    name: "akademie",
    meta: createAcademyMeta({ navbarTitle: "Akademie", backTo: "/dashboard", rights: allAcademyRights }),
    component: () => import("@/views/akademie/AkademieMain.vue"),
    redirect: () => {
      const hasClassicAccess = userService.hasRight(...classicAcademyRights)
      const hasLeadershipAccess = userService.hasRight("aka_leadership", "aka_leadership_manage")
      const hasPreviewAccess = userService.hasRight("aka_preview")
      if (hasClassicAccess && !hasPreviewAccess) return "/akademie/schulungen"
      return hasLeadershipAccess && !hasClassicAccess ? "/akademie/leadership" : "/akademie/suite"
    },
    children: [
      {
        path: "suite",
        name: "akademieSuite",
        meta: createAcademyMeta({ navbarTitle: "Learning Suite", backTo: "/dashboard", rights: classicAcademyRights }),
        component: () => import("@/views/akademie/LearningSuite.vue"),
      },
      {
        path: "kreativwerkstatt",
        name: "akademieKreativ",
        meta: createAcademyMeta({ navbarTitle: "Kreativwerkstatt", backTo: "/dashboard", rights: classicAcademyRights }),
        component: () => import("@/views/akademie/Kreativwerkstatt.vue"),
      },
      {
        path: "schulungen",
        name: "akademieSchulungen",
        meta: createAcademyMeta({ navbarTitle: "Schulungsplan", backTo: "/dashboard", rights: classicAcademyRights }),
        component: () => import("@/views/akademie/Schulungsplan.vue"),
      },
      {
        path: "leadership",
        name: "akademieLeadership",
        meta: createAcademyMeta({
          navbarTitle: "Leadership",
          backTo: "/dashboard",
          rights: ["aka_leadership", "aka_leadership_manage"],
        }),
        component: () => import("@/views/akademie/leadership/LeadershipHome.vue"),
      },
      {
        path: "leadership/coaching",
        name: "akademieLeadershipCoaching",
        meta: createAcademyMeta({
          navbarTitle: "Leadership Coaching",
          backTo: "/akademie/leadership",
          rights: ["aka_leadership", "aka_leadership_manage"],
        }),
        component: () => import("@/views/akademie/leadership/LeadershipCoaching.vue"),
      },
      {
        path: "leadership/connect",
        name: "akademieLeadershipConnect",
        meta: createAcademyMeta({
          navbarTitle: "Leadership Connect",
          backTo: "/akademie/leadership",
          rights: ["aka_leadership", "aka_leadership_manage"],
        }),
        component: () => import("@/views/akademie/leadership/LeadershipConnect.vue"),
      },
      {
        path: "leadership/coaching-1to1",
        name: "akademieLeadershipCoachingOneToOne",
        meta: createAcademyMeta({
          navbarTitle: "Leadership Coaching 1:1",
          backTo: "/akademie/leadership",
          rights: ["aka_leadership", "aka_leadership_manage"],
        }),
        component: () => import("@/views/akademie/leadership/LeadershipCoachingOneToOne.vue"),
      },
    ],
  },
  {
    path: "/akademie-teacher",
    name: "akademieTeacherDashboard",
    meta: createAcademyMeta({ navbarTitle: "Teacher Dashboard", backTo: "/akademie", rights: ["aka_teacher", "aka_manage"] }),
    component: () => import("@/views/akademie/teacher/TeacherDashboard.vue"),
  },

  {
    path: "/akademie/modules/:id",
    name: "akademieModuleDetail",
    meta: createAcademyMeta({ navbarTitle: "Akademie Modul", backTo: getAcademyTrackPath, rights: allAcademyRights }),
    component: () => import("@/views/akademie/ModuleDetail.vue"),
  },
  {
    path: "/akademie/modules/:id/lessons/:lessonId",
    name: "akademieLessonPlayer",
    meta: createAcademyMeta({ navbarTitle: "Akademie Lektion", backTo: getAcademyModulePath, rights: allAcademyRights }),
    component: () => import("@/views/akademie/LessonPlayer.vue"),
  },
  {
    path: "/akademie/modules/:id/quiz",
    name: "akademieQuizPlayer",
    meta: createAcademyMeta({ navbarTitle: "Akademie Wissenstest", backTo: getAcademyModulePath, rights: allAcademyRights }),
    component: () => import("@/views/akademie/QuizPlayer.vue"),
  },
  {
    path: "/akademie/schulungen/:id",
    name: "akademieSchulungDetail",
    meta: createAcademyMeta({ navbarTitle: "Schulungsdetails", backTo: "/akademie/schulungen", rights: classicAcademyRights }),
    component: () => import("@/views/akademie/SchulungDetail.vue"),
  },
  {
    path: "/akademie/kreativwerkstatt/:id",
    name: "akademieKreativBoard",
    meta: createAcademyMeta({ navbarTitle: "Kreativwerkstatt", backTo: "/akademie/kreativwerkstatt", rights: classicAcademyRights }),
    component: () => import("@/views/akademie/KreativBoard.vue"),
  },
  {
    path: "/akademie-admin",
    name: "akademieAdmin",
    meta: createAcademyMeta({ navbarTitle: "Akademie Administration", backTo: "/akademie", rights: ["aka_manage"] }),
    component: () => import("@/views/akademie/admin/AkademieAdmin.vue"),
  },
  {
    path: "/akademie-leadership-admin",
    name: "akademieLeadershipAdmin",
    meta: createAcademyMeta({
      navbarTitle: "Leadership Administration",
      backTo: "/akademie/leadership",
      rights: ["aka_leadership_manage"],
    }),
    component: () => import("@/views/akademie/admin/LeadershipAdmin.vue"),
  },
  {
    path: "/akademie-teacher/user/:id",
    name: "akademieTeacherUser",
    meta: createAcademyMeta({ navbarTitle: "Mitarbeiter-Kartei", backTo: "/akademie-teacher", rights: ["aka_teacher", "aka_manage"] }),
    component: () => import("@/views/akademie/teacher/UserKartei.vue"),
  },
  // --- AKADEMIE MODUL ENDE ---

  {
    name: "workCalendar",
    path: "/work-calendar",
    meta: { hideBottomNavigation: true, backgroundColor: "#121212", hideAppBar: true, fullWidth: true },
    component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/workCalendar/workCalendar.vue"),
  },
  {
    path: "/panel",
    name: "employeePanel",
    meta: { hideBottomNavigation: true, hideAppBar: true, fullWidth: true },
    component: () => import("@/views/employee/employeePanel.vue"),
    children: [
      {
        path: "membercard",
        name: "MembercardView",
        meta: { hideBottomNavigation: true },
        component: () => import("@/views/employee/MembercardView.vue"),
      },
    ],
  },
  {
    path: "*",
    name: "catchAll",
    meta: { backgroundColor: "#212121" },
    component: () => import(/* webpackChunkName: "HomeNew.vue" */ "@/views/HomeNew_new.vue"),
  },
  { path: "/consent", name: "consent", component: consentthing },
  {
    path: "/forgot",
    name: "Forgot",
    component: () => import("@/views/launchScreen/launchScreen.vue"),
  },
  {
    path: "/login",
    name: "login",
    meta: { hideAppBar: true },
    component: () => import("@/views/launchScreen/launchScreen.vue"),
  },
  {
    path: "/register",
    name: "Registrieren",
    component: () => import("@/views/launchScreen/launchScreen.vue"),
  },
]
